<template>
  <admin-page-shell :title="$t('frontend_groovemail_admin_alerts')">
    <server-table
      class="text-center groovemail-admin-user-alert-table"
      ref="serverTable"
      :url="`user-alerts/${user_id}`"
      tableRef="spamAlertTable"
      :slotData="userAlertsTableSlotData"
      :tableColumns="spam_alertsTableColumns"
      :tableOptions="spam_alertTableOptions"
      @loaded="hideLoader()"
      @loading="showLoader()"
    />

    <!-- Confirmation delete modal -->
    <confirm-modal
      :ref="`confirmation-action`"
      :name="`confirmation-action`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="confirmMessage"
      @confirm="confirmAction"
      @close="closeConfirmationActionModal"
    />
  </admin-page-shell>
</template>
<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import AdminPageShell from '../AdminPageShell.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';
import { showRequestErrorAlert } from '@/components/showDialog.js';


let self;

export default {
  middleware: 'auth',
  metaInfo() {
    return {
      title: this.$t(
        'frontend_groovemail_components_pricepoint_sidebar_broadcasts'
      ),
    };
  },

  mixins: [demoModeValuesMixin],

  data() {
    return {
      tableKey: 1,
      last_page: '',
      user_id: this.$route.params.id,
      fullPageLoader: true,
      model: {
        from: '',
        to: '',
        subject: '',
        content: '',
      },
      spam_alertsTableColumns: [
        'user.email',
        'created_at',
        'name',
        'total_recipients',
        'total_spam',
        'total_bounced',
        'actions',
      ],
      spam_alertTableOptions: {
        perPage: 25,
        debounce: 1000,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        filterable: true,
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortable: ['total_recipients', 'total_spam', 'total_bounced'],
        headings: {
          'user.email': () => this.$t('frontend_groovemail_spam_alert_username'),
          created_at: () => this.$t('frontend_groovemail_spam_alert_date'),
          email: () => this.$t('frontend_groovemail_spam_alert_email'),
          total_recipients: () =>
            this.$t('frontend_groovemail_spam_alert_recipients'),
          total_spam: () => this.$t('frontend_groovemail_spam_alert_spam'),
          total_bounced: () =>
            this.$t('frontend_groovemail_spam_alert_bounces'),
          actions: () => this.$t('frontend_groovemail_spam_alert_action'),
        },
        requestFunction(data) {
          const requestParams = { ...data, ascending: 1 - data.ascending };
          const self = this;
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
            });
        },
        responseAdapter({ data }) {
          if(self.demoMode) {
            const newData = data?.data.map((obj) => ({
              ...obj,
              user: {
                ...obj.user,
                email: self.basicEmailText
              },
              name: self.basicText
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }
          return {
            data: data.data,
            count: data.total,
          };
        },
      },

      confirmMessage: '',
      confirmTarget: '',
      confirmId: null,
    };
  },

  created() {
    self=this;
  },

  watch: {
    // Used to refresh black list table when demo mode changes
    demoMode() {
      this.$refs.serverTable.$refs.spamAlertTable.refresh();
    },
  },

  components: {
    AdminPageShell,
    VuePerfectScrollbar,
    ServerTable,
  },
  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },

    showcampaign(Id) {
      this.$router.push({
        name: 'CampaignDetail',
        params: { id: Id },
        query: { from: 'broadcast-listing' },
      });
    },
    openEditMailsequence(seqId) {
      this.$router.push({
        name: 'Sequencestep',
        params: { id: seqId },
      });
    },
    showalerthistory(userId) {
      this.$router.push({
        name: 'usersalerts',
        params: { id: userId },
      });
    },
    // openemail(row) {
    //   this.model.from = row.firstrecipient.sender;
    //   this.model.to = row.firstrecipient.recipient;
    //   this.model.subject = row.firstrecipient.subject;
    //   this.model.content = row.firstrecipient.content;
    //   this.$root.$emit('modal-open', 'view-campaign-modal');
    // },

    // open confirmation action modal
    async openConfirmationActionModal(target, id) {
      this.confirmId = id;
      this.confirmTarget = target;

      // set the Confirm message based on the target
      if (target === 'loginOwnerAccount') {
        this.confirmMessage = this.$t('frontend_groovemail_spam_alert_login_to_owner_account');
      } else if (target === 'removeAlert') {
        this.confirmMessage = this.$t('frontend_groovemail_spam_alert_are_you_sure');
      }

      // open the modal
      this.$refs[`confirmation-action`].open();
    },

    // close confirmation action modal
    closeConfirmationActionModal() {
      // reset the Confirm data
      this.confirmMessage = '';
      this.confirmTarget = '';
      this.confirmId = null;
    },

    // confirm action
    confirmAction() {
      if (this.confirmTarget === 'loginOwnerAccount') {
        this.loginOwnerAccount();
      } else if (this.confirmTarget === 'removeAlert') {
        this.removeAlert();
      }
    },
    
    // login to owner account
    async loginOwnerAccount() {
      // need functionality to login to owner account
    },

    // remove alert
    async removeAlert() {
      try {
        this.showLoader();

        // remove alert
        await axios.delete(`/spam-alerts/${this.confirmId}`);

        // after removing alert, refresh the table
        const alertData = await axios.get(
          `/user-alerts/${this.user_id}?query=${this.$refs.spamAlertTable.filteredQuery}&limit=${this.spam_alertTableOptions.perPage}&page=${this.$refs.spamAlertTable.Page}&ascending=1&byColumn=0`
        );
        this.$refs.spamAlertTable.data = alertData.data.data;
        this.$refs.spamAlertTable.count = alertData.data.total;
        this.hideLoader();
      }
      catch (error) {
        this.hideLoader();

        // show error alert
        await showRequestErrorAlert(error?.response?.data?.error);
      }
    },
  },

  computed: {
    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },
    
    months() {
      return [
        this.$t('frontend_groovemail_month_jan_short'),
        this.$t('frontend_groovemail_month_feb_short'),
        this.$t('frontend_groovemail_month_mar_short'),
        this.$t('frontend_groovemail_month_apr_short'),
        this.$t('frontend_groovemail_month_may_short'),
        this.$t('frontend_groovemail_month_jun_short'),
        this.$t('frontend_groovemail_month_jul_short'),
        this.$t('frontend_groovemail_month_aug_short'),
        this.$t('frontend_groovemail_month_sep_short'),
        this.$t('frontend_groovemail_month_oct_short'),
        this.$t('frontend_groovemail_month_nov_short'),
        this.$t('frontend_groovemail_month_dec_short'),
      ];
    },

    userAlertsTableSlotData() {
      return [
        {
          slotName: 'username',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.email ? props.row.email : 0;
          },
        },
        {
          slotName: 'total_alerts',
          slotType: 'clickable',
          classes: 'hover:underline',
          defaultValue: 0,
          callback: (props) => this.showalerthistory(props.row.user_id),
        },
        {
          slotName: 'created_at',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.created_at
              ? `${new Date(props.row.created_at).getDate()} ${
                  this.months[new Date(props.row.created_at).getMonth()]
                }, ${new Date(props.row.created_at).getFullYear()}`
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'name',
          slotType: 'clickable',
          callback: (props) => {
            if (props.row.source == 1) this.showcampaign(props.row.source_id);
            else if (props.row.source == 3)
              this.openEditMailsequence(props.row.source_id);
          },
          classes: 'hover:underline',
          defaultValue: this.$t('frontend_groovemail_not_available'),
        },
        {
          slotName: 'total_recipients',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.total_recipients ? props.row.total_recipients : 0;
          },
        },
        {
          slotName: 'total_spam',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return `${props.row.total_spam ? props.row.total_spam : 0} (${
              props.row.total_spam && props.row.total_recipients
                ? (props.row.total_spam * 100) / props.row.total_recipients
                : 0
            }%)`;
          },
        },
        {
          slotName: 'total_bounced',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return `${props.row.total_bounced ? props.row.total_bounced : 0} (${
              props.row.total_bounced && props.row.total_recipients
                ? (props.row.total_bounced * 100) / props.row.total_recipients
                : 0
            }%)`;
          },
        },
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: () => {
            return true;
          },
          classes: () => {
            return {
              outerDiv: '',
              dropdown: '',
              outerSpan: '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => this.$t('frontend_groovemail_spam_alert_remove'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.openConfirmationActionModal('removeAlert', props.row.id),
            },
            {
              id: 1,
              name: () => this.$t('frontend_groovemail_login_to_owner_account'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.openConfirmationActionModal('loginOwnerAccount', props.row.id)
            },
          ],
        },
      ];
    },
  },
};
</script>


<style lang="scss">
.groovemail-admin-user-alert-table #gd-server-table-view {
  .VueTables--server table {
    th:nth-child(1),
    td:nth-child(6) {
      width: 8%;
    }
    td:nth-child(1) {
      width: 20%;
      word-break: break-word;
    }
  }
}
</style>
